import { Component, ElementRef, Input, ViewChild, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ConfigureService } from '@app/configure/services/configure.service';
import { SessionService } from '@app/core/services/session.service';
import { ModalService } from '@app/core/services/modal.service';

import { Dealer } from '@app/core/models/dealer.model';

@Component({
	selector: 'ui-dealer-header',
	templateUrl: './dealer-header.component.html',
	styleUrls: ['./dealer-header.component.less'],
})
export class UIDealerHeaderComponent implements OnInit {
	@Input() callback_enabled: boolean = false;
	@Input() quote_ref: string = null;
	@Input() location: string = '';

	@ViewChild('header') header: ElementRef;

	dealer: Dealer = this.session_service.getDealer();
	website_url: string = this.dealer.website_url || null;
	configure_data = this.configure_service.configure_data;

	private destroyed$: Subject<boolean> = new Subject<boolean>();

	@ViewChild('dealerName') dealer_name: ElementRef;
	@ViewChild('dealerLogo') dealer_logo: ElementRef;

	constructor(
		private session_service: SessionService,
		private modal_service: ModalService,
		private configure_service: ConfigureService
	) {}

	ngOnInit(): void {
		this.configure_service.configure_data$.pipe(takeUntil(this.destroyed$)).subscribe((configure_data) => {
			this.configure_data = configure_data;
		});
	}

	handleDealerLogoError(): void {
		this.dealer_name.nativeElement.classList.add('force-show');
		this.dealer_logo.nativeElement.classList.add('force-hide');
	}

	onShowMap(): void {
		this.modal_service.show(['dealer/map']);
	}

	onShowContact(): void {
		this.modal_service.show(['dealer/contact'], {
			quote_ref: this.quote_ref,
			callback_enabled: this.callback_enabled,
		});
	}

	onShowCallback(): void {
		this.modal_service.show(['configure/callback']);
	}
}
